$( document ).on("turbo:load", initStructureBeaconModal);

function initStructureBeaconModal() {
  if ($('#beacon-modal').length > 0) {
    $('[data-function="existing-beacon-list"]').hide();
    $('a[data-function="existing-beacon"]').click(function(e){
      e.preventDefault();
      $('[data-function="existing-beacon-list"]').show();
    });
  }
}
